module.exports = __webpack_public_path__ + "assets/images/announcement-co2-heartbeat.png";